import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface SubmitBlockerOverlayProps {
  open: boolean;
}

/**
 * Full-screen blocker shown from the moment Submit is pressed until the
 * submit settles, so nothing can be changed or clicked while the rebase and
 * submit are in flight. Styled to match the Edit Online "Publish changes are
 * in progress" backdrop.
 */
export const SubmitBlockerOverlay = ({ open }: SubmitBlockerOverlayProps) => (
  <Backdrop
    open={open}
    sx={{
      color: 'white',
      zIndex: (theme) => theme.zIndex.drawer + 3,
      backgroundColor: alpha('#596B7A', 0.7),
    }}
  >
    <Stack
      direction="column"
      spacing={2}
      alignItems="center"
      role="status"
      aria-live="polite"
    >
      <CircularProgress color="primary" />
      <Typography variant="h6">Submitting your resolution</Typography>
    </Stack>
  </Backdrop>
);

export default SubmitBlockerOverlay;
